export default __webpack_public_path__ + "static/media/intel10400.680c1807.jpg";